<template>
  <v-container fluid>
    <div class="esign-backbar">
      <v-btn text class="esign-back-btn" @click="back">
        <v-icon left>mdi-arrow-left</v-icon> Kembali
      </v-btn>
    </div>
    <v-row class="esign-detail-grid">
      <v-col cols="12" :lg="linimasa.length > 0 ? 7 : 12">
        <material-card
          color="primary"
          title="Detail Dokumen"
          class="card-wrapper"
        >
          <!-- Document actions next to the title; cancelling lives in the ⋮ menu -->
          <template v-slot:head-actions>
            <v-btn outlined color="primary" @click="preview">
              <v-icon left small>mdi-eye-outline</v-icon>Preview Dokumen
            </v-btn>
            <v-btn v-if="isTtd" outlined color="primary" @click="lihatHistori(item)">
              <v-icon left small>mdi-history</v-icon>Histori Tanda Tangan Anda
            </v-btn>
            <v-btn v-if="idStatus === 3" depressed color="primary" @click="download()">
              <v-icon left small>mdi-download</v-icon>Download
            </v-btn>
            <v-menu v-if="idStatus !== 3 && idStatus !== 4 && peran==='A02'" offset-y left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon aria-label="Aksi lainnya" v-bind="attrs" v-on="on">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item @click="cancel_dialog = true">
                  <v-list-item-icon><v-icon color="error">mdi-close-circle-outline</v-icon></v-list-item-icon>
                  <v-list-item-title class="error--text">Batalkan pengajuan</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
          <div v-if="this.batch">
            <div class="esign-detail">
              <div class="row">
                <div class="col-4">
                  <p class="label font-weight-bold mb-1">Nama Batch</p>
                </div>
                <div class="col-8">
                  <p class="label">{{ batch.batch_name }}</p>
                </div>
              </div>
              <div class="row">
                <div class="col-4">
                  <p class="label font-weight-bold mb-1">Tanggal Pengajuan</p>
                </div>
                <div class="col-8">
                  <p class="label">{{ tanggalPengajuan }}</p>
                </div>
              </div>
              <div class="row">
                <div class="col-4">
                  <p class="label font-weight-bold mb-1">Jumlah Dokumen</p>
                </div>
                <div class="col-8">
                  <p class="label">{{ jumlahDokumen }} Dokumen</p>
                </div>
              </div>
              <div class="row">
                <div class="col-4">
                  <p class="label font-weight-bold mb-1">Nama Pengaju</p>
                </div>
                <div class="col-8">
                  <p class="label">{{ usernamePengaju }}</p>
                </div>
              </div>
              <div class="row">
                <div class="col-4">
                  <p class="label font-weight-bold mb-1">Jenis Dokumen</p>
                </div>
                <div class="col-8">
                  <p class="label">{{ jenisDokumen }}</p>
                </div>
              </div>
              <div class="row">
                <div class="col-4">
                  <p class="label font-weight-bold mb-1">Organisasi</p>
                </div>
                <div class="col-8">
                  <p class="label">{{ organisasi }}</p>
                </div>
              </div>
              <div class="row">
                <div class="col-4">
                  <p class="label font-weight-bold mb-1">Workflow Persetujuan</p>
                </div>
                <div class="col-8">
                  <p class="label">{{ workflowPersetujuan }}</p>
                </div>
              </div>
              <div class="row">
                <div class="col-4">
                  <p class="label font-weight-bold mb-1">Status</p>
                </div>
                <div class="col-8">
                  <esign-status-tag :tone="['neutral', 'warning', 'success', 'danger', 'warning'][idStatus - 1]" :value="status" />
                  </div>
              </div>
              <div class="row" v-if="idStatus === 5">
                <div class="col-4">
                  <p class="label font-weight-bold mb-1">Keterangan</p>
                </div>
                <div class="col-8">
                  <p class="label">{{ memoPembatalan }}</p>
                </div>
              </div>
              <div class="row" v-if="catatanSanggahTolak !== ''">
                <div class="col-4">
                  <p class="label font-weight-bold mb-1">Catatan Sanggah Penolakan</p>
                </div>
                <div class="col-8">
                  <p class="label">{{ catatanSanggahTolak }}</p>
                </div>
              </div>
              <div class="row" v-if="keteranganCallback !== ''">
                <div class="col-4">
                  <p class="label font-weight-bold mb-1">Keterangan Callback</p>
                </div>
                <div class="col-8">
                  <p class="label">{{ keteranganCallback }}</p>
                </div>
              </div>
            </div>

            <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="8000" :top="true">
              {{ snackbarText }}
              <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-row>
              <v-dialog
                v-model="dialog"
                persistent
                style="z-index:99999;"
              >
                <v-card>
                  <v-card-title class="text-h5 grey lighten-2">
                    Preview Dokumen
                  </v-card-title>
                  <v-card-text>
                    <DragAndDrop
                      :source="sourcePdf"
                      :ttd-items="imagePdfItems"
                      :dialog="dialog"
                      :permission="'Detail'"
                    >
                    </DragAndDrop>
                  </v-card-text>
                  <v-divider></v-divider>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="primary"
                      text
                      @click="dialog = false"
                    >
                      Tutup
                    </v-btn>
                    </v-card-actions>
                  </v-card>
              </v-dialog>
            </v-row>
            <esign-confirm-dialog
              v-model="cancel_dialog"
              persistent
              title="Batalkan pengajuan?"
              confirm-text="Batalkan pengajuan"
              :loading="loadingCancel"
              :cancel-disabled="batalCancel"
              @confirm="proceedCancel()"
            >
              Pengajuan <b>{{ jenisDokumen }}</b> dengan nama batch <b>{{ batch.batch_name }}</b> akan dihapus,
              dan proses pengajuan harus diulang dari awal.
            </esign-confirm-dialog>
            <v-dialog v-model="historiDialog" max-width="800px">
              <v-card>
                <v-card-title class="text-h5 grey lighten-2 mb-3">
                  Histori Penandatanganan Batch
                </v-card-title>
                <v-card-text>
                  <!-- Loading -->
                  <v-row justify="center" v-if="loadingHistori">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  </v-row>

                  <!-- Header Info -->
                  <div v-if="!loadingHistori && historiHeader">
                    <p><b>Batch Name:</b> {{ historiHeader.batch_name }}</p>
                    <p><b>Penandatangan:</b> {{ user.pengguna.nama_lengkap }}</p>
                    <p><b>Nama Jenis Dokumen:</b> {{ historiHeader.nama_jenis_dokumen }}</p>
                    <p><b>Alur Persetujuan:</b> {{ historiHeader.alur_persetujuan }}</p>
                    <v-divider class="my-3"></v-divider>
                  </div>

                  <!-- Tabel Histori -->
                  <v-data-table
                    v-if="!loadingHistori"
                    :headers="[
                      { text: 'Created At', value: 'created_at' },
                      { text: 'Status', value: 'status' },
                      { text: 'Error Message', value: 'error_message' }
                    ]"
                    :items="historiList"
                    dense
                    no-data-text="Tidak ada histori"
                    hide-default-footer
                    :items-per-page="-1"
                  >
                    <!-- Format tanggal -->
                    <template v-slot:item.created_at="{ value }">
                      {{ value ? formatTanggal(value) : '-' }}
                    </template>

                    <!-- Error message null -->
                    <template v-slot:item.error_message="{ value }">
                      {{ value ? value : '-' }}
                    </template>

                    <!-- Status dengan chip -->
                    <template v-slot:item.status="{ value }">
                      <esign-status-tag :tone="value === 'FINISHED' ? 'success' : (value === 'FAILED' ? 'danger' : 'warning')" :value="value" />
                    </template>
                  </v-data-table>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="historiDialog = false">
                    Tutup
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
          <div v-else>
              <h4 class="text-center">Tidak ada data</h4>
          </div>
        </material-card>
      </v-col>
      <v-col v-if="linimasa.length > 0" cols="12" lg="5">
        <material-card
          color="primary"
          title="Riwayat Penandatanganan"
          class="card-wrapper esign-timeline-card"
        >
          <div class="esign-timeline">
            <v-timeline align-top dense>
              <v-timeline-item style="padding-bottom:15px" dark fill-dot color="cyan">
                <v-row justify="space-between">
                  <v-col cols="5">
                    <v-chip color="cyan" label>
                      Dokumen diajukan
                    </v-chip>
                    <div class="text-caption">{{ tanggalPengajuan }}</div>
                  </v-col>
                  <v-col cols="3">
                    <p><strong>{{ usernamePengaju }}</strong></p>
                  </v-col>
                  <v-col cols="4">
                    <v-chip>
                      <v-icon>mdi-send</v-icon>&nbsp;Pengaju
                    </v-chip>
                  </v-col>
                </v-row><v-divider light class="mb-2" />
              </v-timeline-item>
              <v-timeline-item style="padding-bottom:15px" dark fill-dot v-for="(item, i) in linimasa" :key="i" :color="item.color">
                <template v-slot:icon>
                  <v-icon dark size="30">{{ item.icon }}</v-icon>
                </template>
                <v-row class="justify-center" v-if="item.posisi && workflowPersetujuan === 'Berjenjang'"><v-chip class="mb-3" color="green" label>{{ item.posisi }}</v-chip></v-row>
                <v-row justify="space-between">
                  <v-col cols="5">
                    <v-chip small v-if="workflowPersetujuan !== 'Grup'" :color="item.color" label>
                      {{ item.no }}
                    </v-chip>&nbsp;
                    <strong>{{ item.deskripsi }}</strong>
                    <div class="text-caption"><strong>{{ item.last_update }}</strong></div>
                  </v-col>
                  <v-col cols="3">
                    <p><strong>{{ item.pengguna.nama_lengkap }}</strong></p>
                    <div class="text-caption">{{ item.jabatan }}</div>
                  </v-col>
                  <v-col cols="4">
                    <v-chip>
                      <v-icon>{{item.icon_ttd}}</v-icon>&nbsp;{{ item.tipe }}
                    </v-chip>
                  </v-col>
                </v-row><v-divider light class="mb-4" />
              </v-timeline-item>
              <v-timeline-item dark fill-dot v-if="idStatus === 3" color="primary">
                <template v-slot:icon>
                  <v-icon dark size="30">mdi-check-bold</v-icon>
                </template>
                <v-row justify="space-between">
                  <v-col cols="5">
                    <v-chip color="primary" label>Selesai</v-chip>
                  </v-col>
                </v-row>
              </v-timeline-item>
            </v-timeline>
          </div>
        </material-card>
      </v-col>
    </v-row>
    <v-overlay
      :opacity="0.5"
      :value="overlay"
    >
      <v-progress-circular indeterminate size="64">
        Loading...
      </v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
  import { apiServer, docConverter } from "@/setup-axios";
  import DragAndDrop from "../jenisDokumenOrganisasi/DragAndDrop.vue";
  import { documentPath } from '@/config/env';

  var moment = require('moment');
  export default {
    data: () => ({
      page: 1,
      numPages: 0,
      search: "",
      snackbar: false,
      snackbarText: "",
      snackbarColor: "",
      isLoading: true,
      batalCancel: false,
      loadingCancel: false,
      batalConfirmReject: false,
      loadingConfirmReject: false,
      batalDenyReject: false,
      loadingDenyReject: false,
      batalReject: false,
      loadingReject: false,
      showPassword: false,
      batch: null,
      ttdBatch: [],
      tanggalPengajuan:"",
      lokasiTanggal:"",
      jenisDokumen: "",
      organisasi: "",
      fileStampOrganisasi: "",
      fileDokumen: "",
      lokasiDokumen: "",
      idStatus: null,
      status: "",
      daftarPemaraf: [],
      daftarPenandatangan: [],
      chosenIdJenisTtds: [],
      chosenJenisTtds: [],
      items: [],
      linimasa:[],
      overlay: false,
      batchForm: {
        id_batch: null,
        passphrase:"",
        id_user_login: null,
        id_ttd_batch: null
      },
      usernamePengaju:"",
      allow_reject: true,
      pengajuForm: {
        id_ttd_arsip_dokumen: null,
        next_id_ttd_arsip_dokumen: -1,
        id_arsip_dokumen: null
      },
      keterangan_sanggah_tolak: "",
      rejectRequest: {
        id_ttd_arsip_dokumen: null,
        next_id_ttd_arsip_dokumen: -1,
        username_pengaju: "",
        keterangan: "",
        flag_visual:null,
        nama_jenis_dokumen: "",
        id_arsip_dokumen: null
      },
      sourcePdf: null,
      finalPdf: null,
      dialog: false,
      cancel_dialog: false,
      confirm_reject_dialog: false,
      deny_reject_dialog: false,
      reject_dialog:false,
      memoPembatalan:"",
      catatanSanggahTolak: "",
      keteranganCallback:"",
      eligiblePengguna: [],
      options: {},
      totalData: 0,
      jumlahDokumen: 0,
      peran: "",
      user: null,
      workflowPersetujuan:"",
      isEligible: false,
      tingkatKerahasiaan : "",
      idTingkatKerahasiaan: null,
      errorMessagePassphrase: "",
      dragAndDropKey: 0,
      bsre_text: "",
      bsre_text_img: "",
      bsre_user_text: "",
      show_bsre: false,
      api_path: "",
      api_path_sign: "",
      ttdText: "",
      blob_data: null,
      blob_final_data: null,
      imagePdfItems: [],
      isTtd: false,
      historiDialog: false,
      historiList: [],
      historiHeader: null,
      loadingHistori: false,
    }),
    watch: {
      options: {
        handler() {
          this.getData()
        },
        deep: true
      },
    },
    components :{ DragAndDrop },
    async created() {
      this.peran = localStorage.getItem("currentPeran")
      this.user= JSON.parse(localStorage.getItem("user"))
      if (this.$store.state.snackbar.snackbarText != null) {
        this.showMessage()
      }
      if (this.peran === 'A02' || this.peran === 'A03') {
        await this.getListEligibleIdPengguna(this.$route.params.id)
        if (!this.eligiblePengguna.includes(this.user.id)) {
          this.$router.push('/403');
        }
      }
      this.getData(this.$route.params.id)
    },
    methods: {
      async getListEligibleIdPengguna(id) {
        await apiServer
          .get("/batch/eligible_pengguna/" + id)
          .then(response => {
            this.eligiblePengguna = response.data.data
          })
          .catch(error => {
            this.showSnackbar("error", error.response.data.message)
          });
      },
      checkIsTtd(ttdBatch) {
        if (!ttdBatch || ttdBatch.length === 0) return false

        return ttdBatch.some(item =>
          item.id_pengguna === this.user.id && item.flag_urutan === true
        )
      },
      getData(id) {
        this.isLoading = true;
        apiServer
          .get("/batch/" + id)
          .then(async response => {
            this.batch = response.data.data.batch
            this.tanggalPengajuan = moment.utc(this.batch.tanggal_entry).locale("id").format('DD-MM-YYYY HH:mm:ss')
            this.lokasiTanggal = this.batch.tanggal_entry.substring(0, 7)
            if(localStorage.getItem("success") != null) {
              this.showSnackbar("success", localStorage.getItem("success"));
              localStorage.removeItem("success")
            }
            this.jumlahDokumen = response.data.data.jumlah_dokumen
            this.usernamePengaju = this.batch.pengguna_entry
            this.organisasi = response.data.data.organisasi.nama
            this.jenisDokumen = response.data.data.jenis_dokumen.nama
            this.workflowPersetujuan = response.data.data.jenis_dokumen.alur_persetujuan
            this.idStatus = response.data.data.status.id
            this.status = response.data.data.status.nama
            this.keteranganCallback = this.batch.keterangan_callback
            this.batchForm.id_batch = response.data.data.batch.id_batch
            this.batchForm.id_user_login = this.user.id
            this.ttdBatch = response.data.data.ttd_batch
            this.fileDokumen = response.data.data.first_file_dokumen
            this.isTtd = this.checkIsTtd(this.ttdBatch)

            if (this.isTtd) {
              this.getDataHistori();
            }

            this.getDaftarPemaraf()
            this.getDaftarPenandatangan()
            this.loadLinimasa()
            await this.loadSourcePdf()
          })
          .catch(error => {
            this.showSnackbar("error", error.response.data.message)
          })
          .finally(() => {
            this.isLoading = false
          });
      },
      formatTanggal(tanggal) {
        return moment.utc(tanggal).locale("id").format('DD-MM-YYYY HH:mm:ss')
      },
      getDaftarPemaraf() {
        this.ttdBatch.forEach((item, _) => {
          if (item.tipe_ttd === 1) {
            this.daftarPemaraf.push(item)
          }
        })
        this.daftarPemaraf.sort((a, b) => {
            return a.urutan_ttd - b.urutan_ttd;
        });
        this.daftarPemaraf.forEach((item, _) => {
          this.linimasa.push(item)
        })
      },
      getDaftarPenandatangan() {
        this.ttdBatch.forEach((item, _) => {
          if (item.tipe_ttd === 2) {
            this.daftarPenandatangan.push(item)
          }
        })
        this.daftarPenandatangan.sort((a, b) => {
            return a.urutan_ttd - b.urutan_ttd;
        });
        this.daftarPenandatangan.forEach((item, _) => {
          this.linimasa.push(item)
        })
      },
      loadLinimasa() {
        this.linimasa.forEach((item, index) => {
          item.no=index+1
          //deskripsi
          if (item.flag_ttd === false && item.flag_urutan === true) {
            if (item.id_pengguna === this.user.id && this.peran === 'A03' && this.idStatus !== 5 && this.idStatus !== 4) {
              item.posisi="Posisi Tandatangan saat ini"
              item.icon="mdi-play"
              item.color="green"
              if (item.tipe_ttd === 1) {
                item.deskripsi="Siap diparaf"
              } else if (item.tipe_ttd === 2){
                item.deskripsi="Siap ditandatangan"
              }
            } else if (this.idStatus === 5 && item.keterangan) {
              item.icon="mdi-cancel"
              item.color="error"
              item.deskripsi="Penolakan sedang direview"
            } else if (this.idStatus === 4 && item.keterangan) {
              item.icon="mdi-cancel"
              item.color="error"
              item.deskripsi="Menolak"
            } else {
              item.icon="mdi-clock"
              item.color="orange"
              if (item.tipe_ttd === 1) {
                item.deskripsi="Menunggu diparaf"
              } else if (item.tipe_ttd === 2){
                item.deskripsi="Menunggu ditandatangan"
              }
            }
          } else if (item.flag_ttd === false && item.flag_urutan === false){
            if (this.idStatus === 4) {
              if (item.keterangan) {
                item.icon="mdi-cancel"
                item.color="error"
                item.deskripsi="Menolak"
              } else  {
                item.icon="mdi-cancel"
                item.color="error"
                item.deskripsi="Dibatalkan"
              }
            } else {
              item.icon="mdi-clock"
              item.color="yellow"
              item.deskripsi="Menunggu Urutan"
            }
          } else if (item.keterangan) {
            item.icon="mdi-cancel"
            item.color="error"
            item.deskripsi="Menolak"
          } else if (item.flag_ttd === true) {
            item.icon="mdi-check-bold"
            item.color="primary"
            if (item.tipe_ttd === 1) {
              item.deskripsi="Telah diparaf"
            } else if (item.tipe_ttd === 2){
              item.deskripsi="Telah ditandatangan"
            }
          }
          //tipe ttd
          if (item.tipe_ttd === 1) {
            item.icon_ttd="mdi-pen"
            item.tipe="Pemaraf"
          } else {
            item.icon_ttd="mdi-fountain-pen-tip"
            item.tipe="Penandatangan"
          }
          //last update
          if (item.tanggal_update != null) {
            item.last_update = "Terakhir diupdate: " + this.formatTanggal(item.tanggal_update)
          } else {
            item.last_update = ""
          }
          if (item.keterangan_sanggah_tolak) {
            if (item.id_pengguna === this.user.id || item.pengguna_entry === this.user.username) {
              this.catatanSanggahTolak = "Catatan sanggah penolakan dari pengaju " + item.pengguna_entry + ": " + item.keterangan_sanggah_tolak
            }
          }
          if (item.current_reject) {
            this.memoPembatalan += "Memo penolakan dari " + item.pengguna.nama_lengkap + ": " + item.keterangan
            this.pengajuForm.id_ttd_arsip_dokumen = item.id
            this.pengajuForm.id_arsip_dokumen = item.id_arsip_dokumen
            if (this.workflowPersetujuan === 'Berjenjang') {
              if (this.linimasa[index + 1]) {
                this.pengajuForm.next_id_ttd_arsip_dokumen = this.linimasa[index+1].id
              }
            }
            if (item.flag_visual) {
              this.allow_reject = false
            }
          }
        })
      },
      close() {
        this.cancel_dialog = false
      },
      proceedCancel() {
        this.batalCancel = true
        this.loadingCancel = true
        const batalForm={
          id_batch: Number(this.$route.params.id),
          username_pengaju: this.user.username,
        }
        apiServer
        .put("/batch/cancel_batch", batalForm)
        .then(response => {
          this.batalCancel = false
          this.loadingCancel = false
          if (response.data.status === 'ok') {
            localStorage.setItem('success', "Pengajuan dokumen berhasil dibatalkan")
            this.$router.push('/batch/detail/'+this.$route.params.id);
            window.location.reload();
          } else {
            this.showSnackbar('error', response.data.message)
          }
        })
        .catch(error => {
          this.batalCancel = false
          this.loadingCancel = false
          this.showSnackbar('error', error.response.data.message)
        });
      },
      //sanggah
      preview(){
        this.dialog = true
      },
      back() {
        this.$router.go(-1)
      },
      validSignForm() {
        let valid = false
          if (!this.isEligible) {
            this.showSnackbar("error", "Pengguna tidak dapat menandatangani dokumen ini.")
          } else if (this.signForm.passphrase === "") {
            this.errorMessagePassphrase="Harap isi Passphrase"
            this.showSnackbar("error", this.errorMessagePassphrase)
          } else if (this.signForm.id_ttd_arsip_dokumen === null){
            this.showSnackbar("error", "Proses penandatanganan tidak valid")
          } else {
            valid = true
          }
        return valid
      },
      async sign() {
        this.overlay = true
        if(this.validSignForm()) {
          apiServer
          .put("/arsip/sign", this.signForm)
          .then(response => {
            if (response.data.data === null) {
              localStorage.setItem('success', "Dokumen berhasil ditandatangani")
              this.$router.go('/dokumen/detail/'+this.arsip.id);
              this.overlay = false
            }
          })
          .catch(error => {
            if (error.response.data.message.includes("urutan")) {
              this.showSnackbar("error", error.response.data.message)
            } else {
              this.showSnackbar("error",error.response.data.message);
            }
            this.overlay = false
          });
        }
      },
      showSnackbar(color, message) {
        this.snackbar = true;
        this.snackbarText = message;
        this.snackbarColor = color;
      },
      showMessage () {
        this.showSnackbar(
          this.$store.state.snackbar.snackbarColor,
          this.$store.state.snackbar.snackbarText
        )
        this.$store.dispatch('setSnackbar', {
          snackbarColor: null,
          snackbarText: null,
        })
      },
      async loadSourcePdf() {
        this.sourcePdf = null
        const timestamp = new Date().getTime()
        if(this.fileDokumen) {
          await apiServer
            .get("/files/get-by-filepath?target_path="+documentPath+"/"+this.lokasiTanggal+"/"+this.fileDokumen+"&type=download&timestamp="  + timestamp, {responseType: "blob"})
            .then(async response => {
              var bb = new Blob([response.data])
              var base64Pdf = await this.convertPdfToBase64(bb)
              const timestamp = new Date().getTime()
              await docConverter
                .post("/watermark-document" + '?timestamp=' + timestamp, {
                  pdfBase64: base64Pdf,
                  imgParameter: "",
                  username: JSON.parse(localStorage.getItem("user")).username
                }, {responseType: "blob"})
                .then(response => {
                  bb = new Blob([response.data])
                })
                .catch(error => {
                  this.showSnackbar("error", error.response.data.message)
                });
              const data = window.URL.createObjectURL(bb);
              this.blob_data = bb
              this.sourcePdf = data;
            })
            .catch(error => {
              this.showSnackbar("error", error.response.data.message)
            });
        }
      },
      async download() {
        const timestamp = new Date().getTime()
        const zipFilename = this.batch.batch_name+".zip"
        apiServer
          .get("/files/get-by-filepath?target_path="+documentPath+"/"+this.lokasiTanggal+"/"+zipFilename+"&type=download&timestamp="  + timestamp, {responseType: "blob"})
          .then(response => {
            const bb = new Blob([response.data])
            const data = window.URL.createObjectURL(bb);
            const link = document.createElement('a');
            link.href = data;
            link.setAttribute('download', zipFilename);
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(bb)
          })
          .catch(error => {
            console.log(error)
            console.log("There was an error:", error.response.data.message);
          });
      },
      async convertPdfToBase64(blob) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onload = () => resolve(reader.result);
          reader.onerror = reject;
        });
      },
      getDataHistori() {
        this.loadingHistori = true;
        this.historiList = [];
        this.historiHeader = null;

        apiServer
          .get(
            "/sign-batches/monitorings", {
              params: {
                id_batch: this.batch.id,
                id_user_login: this.user.id
              }}
          )
          .then(async response => {
            const data = response.data.data || [];

            this.historiList = Array.isArray(data) ? data : [];

            if (this.historiList.length > 0) {
              this.historiHeader = {
                batch_name: this.historiList[0].batch_name,
                nama_jenis_dokumen: this.historiList[0].nama_jenis_dokumen,
                alur_persetujuan: this.historiList[0].alur_persetujuan,
              };
            } else {
              this.historiHeader = null;
            }
          })
          .catch(_ => {
            this.showSnackbar("error", "Gagal mengambil histori batch");
          })
          .finally(() => {
            this.loadingHistori = false;
          });
      },
      lihatHistori() {
        this.historiDialog = true;
      },
    }
  };
</script>